// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"440":"news-detail","594":"about","671":"services","794":"cases","983":"products"}[chunkId] + "." + {"440":"fd30d302","594":"1b87b118","671":"bbb0b2f0","794":"1d68aff9","983":"c667595a"}[chunkId] + ".css";
};